import { render, staticRenderFns } from "./PaddleSubscription.vue?vue&type=template&id=51ffd780&scoped=true"
import script from "./PaddleSubscription.vue?vue&type=script&lang=js"
export * from "./PaddleSubscription.vue?vue&type=script&lang=js"
import style0 from "./PaddleSubscription.vue?vue&type=style&index=0&id=51ffd780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffd780",
  null
  
)

export default component.exports